import { getTwitterWidgets, getTwitchEmbed } from '../helpers/thirdPartyScripts';

const twitchEmbedInit = async ({ embeds, blockId }) => {
  const component = embeds.find(embeds => embeds.blockId === blockId && embeds.type === 'twitch_embed');
  if (!component) {
    return;
  }
  if (component.link == null) {
    return;
  }
  const { Twitch } = await getTwitchEmbed();
  if (!Twitch) {
    return;
  }

  const channelName = /(https?:\/\/)?(www.)?twitch.tv\/(.+)\/?/.exec(component.link)[3];
  const embed = new Twitch.Embed(`twitch_embed-${component.blockId}`, {
    width: '100%',
    height: '100%',
    channel: channelName,
    layout: 'video',
    autoplay: true
  });
  const pauseAndSetVolume = () => {
    embed.getPlayer().pause();
    embed.getPlayer().setVolume(0.25);
    embed.removeEventListener(Twitch.Embed.VIDEO_PLAY, pauseAndSetVolume);
  };
  embed.addEventListener(Twitch.Embed.VIDEO_PLAY, pauseAndSetVolume);
};

const facebookFeedInit = () => {
  if (window.outerWidth < 500) {
    [].slice.apply(document.querySelectorAll('[title="facebook feed"]'))
      .forEach(node => {
        const clone = node.cloneNode();
        clone.width = window.outerWidth - 20;
        clone.src = clone.src.replace(/&width=[^&]+&/, `&width=${clone.width}&`);
        node.parentElement.appendChild(clone);
        node.remove();
      });
  }
};

const twitterTimelineInit = async ({ embeds, blockId, block }) => {
  const component = embeds.find(embeds => embeds.blockId === blockId && embeds.type === 'twitter_feed');
  if (!component) {
    return;
  }
  const { twttr } = await getTwitterWidgets();
  if (!twttr) {
    return;
  }
  const targetElement = block.querySelector('.social-embed__component-frame--twitter_feed');
  if (!targetElement) {
    return;
  }

  const options = {
    width: component.width,
    height: 500,
    chrome: 'nofooter noborders',
    theme: component.theme,
    color: '#2B7BB9'
  };
  twttr.widgets.createTimeline({
    sourceType: 'url', url: component.link
  }, targetElement, options);
};

export default async ({ block, blockId, data: { embeds = [] } }) => await Promise.all([
  twitchEmbedInit({ blockId, embeds }),
  facebookFeedInit(),
  twitterTimelineInit({ embeds, blockId, block })
]);
